import { render, staticRenderFns } from "./CreateBetgame.vue?vue&type=template&id=f6b70ee0&scoped=true"
import script from "./CreateBetgame.vue?vue&type=script&lang=js"
export * from "./CreateBetgame.vue?vue&type=script&lang=js"
import style0 from "./CreateBetgame.vue?vue&type=style&index=0&id=f6b70ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b70ee0",
  null
  
)

export default component.exports